"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _makeStyles["default"])(function (theme) {
  return {
    card: function card(props) {
      return {
        overflow: "hidden",
        paddingTop: "56.25%",
        backgroundColor: props.backgroundColour || theme.palette.common.white,
        backgroundImage: "".concat(props.backgroundImage ? "url(".concat(props.backgroundImage, ")") : null),
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroudRepeat: "no-repeat",
        boxSizing: "border-box",
        position: "relative",
        zIndex: "0",
        "&::before": {
          content: "''",
          position: "absolute",
          height: "100%",
          width: "100%",
          top: 0,
          zIndex: "-1"
        },
        "&:hover, &:focus-within": {
          cursor: "pointer",
          "& > div": {
            "&.line-1": {
              transform: "translateY(calc(-100% + ".concat(theme.spacing(props.compact ? 7 : 8), "))")
            },
            "&.line-2": {
              transform: "translateY(calc(-100% + ".concat(theme.spacing(props.compact ? 10 : 11), " + 2px))")
            },
            "&.line-3": {
              transform: "translateY(calc(-100% + ".concat(theme.spacing(props.compact ? 14 : 15), " + 2px))")
            },
            "& .MuiTypography-subtitle2": {
              opacity: 1
            }
          }
        }
      };
    },
    cardInner: function cardInner(props) {
      return {
        position: "absolute",
        boxSizing: "border-box",
        color: "white",
        background: props.backgroundImage ? "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 25%, rgba(0,0,0,0.4) 40%)" : "transparent",
        width: "100%",
        bottom: 0,
        "@media(hover)": {
          bottom: "initial",
          "&.line-1": {
            top: "calc(100% - ".concat(theme.spacing(props.compact ? 7 : 8), ")")
          },
          "&.line-2": {
            top: "calc(100% - ".concat(theme.spacing(props.compact ? 10 : 11), " + 2px)")
          },
          "&.line-3": {
            top: "calc(100% - ".concat(theme.spacing(props.compact ? 14 : 15), " + 2px)")
          }
        },
        transition: "transform .5s ease",
        "& .MuiTypography-subtitle2": {
          transition: "opacity .4s ease",
          transitionDelay: ".2s",
          "@media(hover)": {
            opacity: 0
          }
        },
        "& h2": _defineProperty({
          fontSize: props.compact ? theme.typography.subtitle1 : theme.typography.h6
        }, theme.breakpoints.down('md'), {
          fontSize: props.compact ? theme.typography.subtitle2 : theme.typography.h6
        })
      };
    }
  };
});
function LandingTile(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    backgroundImage = _ref.backgroundImage,
    backgroundColour = _ref.backgroundColour,
    LinkComponent = _ref.LinkComponent,
    compact = _ref.compact;
  var _useState = (0, _react.useState)(1),
    _useState2 = _slicedToArray(_useState, 2),
    lines = _useState2[0],
    setLines = _useState2[1];
  var _useStyles = useStyles({
      backgroundColour: backgroundColour,
      backgroundImage: backgroundImage,
      compact: compact
    }),
    card = _useStyles.card,
    cardInner = _useStyles.cardInner;
  var titleRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var lineHeight = compact ? 28 : 32; // todo: this could change, lets get it from theme
    var lines = Math.round(titleRef.current.offsetHeight / lineHeight);
    setLines(lines);
  }, [titleRef]);
  return /*#__PURE__*/_react["default"].createElement(LinkComponent, {
    color: "inherit"
  }, /*#__PURE__*/_react["default"].createElement(_material.Paper, {
    className: card
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    p: 1,
    pt: 4,
    className: (0, _classnames["default"])(cardInner, "line-".concat(lines))
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h6",
    component: "h2",
    style: {
      lineHeight: 1.2
    },
    ref: titleRef
  }, title), !compact && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: compact ? "caption" : "subtitle2",
    style: {
      lineHeight: 1.25
    }
  }, subTitle || " "))));
}
LandingTile.propTypes = {
  title: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  backgroundColour: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].string,
  compact: _propTypes["default"].bool,
  LinkComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  desktop: _propTypes["default"].bool
};
var _default = exports["default"] = LandingTile;